import { FC } from 'react';
import { Box, Text } from '@chakra-ui/react';

import Heading from 'components/_core/Heading';
import SunshineCard from 'components/_core/SunshineCard';
import SquircleIcon from 'components/_core/SunshineSquircleIcon';

import locales from './locales';

interface MissingBeneficiaryEmailLinkProps {
  onClick: () => void;
}

const MissingBeneficiaryEmailLink: FC<MissingBeneficiaryEmailLinkProps> = ({
  onClick,
}) => (
  <Box marginTop="space-40">
    <Heading as="h2" marginBottom="space-16" size="sm">
      {locales.waitingTitle}
    </Heading>

    <Text>{locales.waitingText}</Text>

    <SunshineCard.Group isBoxed={false} marginTop="space-32">
      <SunshineCard
        alignItems="center"
        onClick={onClick}
        title={locales.addEmailLabel}
      >
        <SunshineCard.Slot name="aside">
          <SquircleIcon name="team" />
        </SunshineCard.Slot>

        <SunshineCard.Content>
          <SunshineCard.Text>{locales.addEmailNote}</SunshineCard.Text>
        </SunshineCard.Content>

        <SunshineCard.Slot name="action">
          <SunshineCard.SunshineIcon name="chevron-right" />
        </SunshineCard.Slot>
      </SunshineCard>
    </SunshineCard.Group>
  </Box>
);

export default MissingBeneficiaryEmailLink;
